import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';


// Import images
import logo from "../../assets1/images/logo.webp";
import usFlag from "../../assets1/images/flags/us.svg";
import frFlag from "../../assets1/images/flags/fr.svg";
import face2 from "../../assets1/images/faces/face2.webp";
import face3 from "../../assets1/images/faces/face3.webp";
import face4 from "../../assets1/images/faces/face4.webp";
import face5 from "../../assets1/images/faces/face5.webp";
import face6 from "../../assets1/images/faces/face6.webp";
import Cookies from 'js-cookie';
import { 
  LayoutGrid, 
  Mail, 
  Bell, 
  User, 
  Edit, 
  Repeat, 
  LogOut, 
  Menu,
  MessageSquare,
  Calendar,
  Gift,
  AlertCircle,
  Layers,
  Download,
  Search,
  Wallet
} from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../Redux/user_information';

const Navbar = ({ toggleSidebar, user }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);
  const [isAppsOpen, setIsAppsOpen] = useState(false);
  const [isMessageOpen, setIsMessageOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoggingOut, setIsLoggingOut] = useState(false);
    const token = useSelector((state) => state.user?.token);
    const userData = useSelector((state) => state.user?.userData);
    console.log("Navbar userData : ",userData);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown')) {
        setIsLanguageOpen(false);
        setIsAppsOpen(false);
        setIsMessageOpen(false);
        setIsNotificationOpen(false);
        setIsProfileOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // Quick apps data
  const quickApps = [
    { icon: MessageSquare, label: "Chat", link: "/chat" },
    { icon: Calendar, label: "Calendar", link: "/calendar" },
    { icon: Mail, label: "Email", link: "/email" },
    { icon: User, label: "Profile", link: "/profile" },
    { icon: Wallet, label: "Wallet", link: "/wallet-transfer" }
  ];

  // Messages data
  const messages = [
    { 
      name: "Leonardo Payne", 
      message: "Project status", 
      time: "2 min ago", 
      img: face2 
    },
    { 
      name: "Carl Henson", 
      message: "Client meeting", 
      time: "30 min ago", 
      img: face3 
    }
  ];

  // Notifications data
  const notifications = [
    { icon: Gift, title: "New Order Received", time: "30 min ago" },
    { icon: AlertCircle, title: "Server Limit Reached!", time: "1 hrs ago" },
    { icon: Layers, title: "Apps are ready for update", time: "5 hrs ago" },
    { icon: Download, title: "Download completed", time: "6 hrs ago" }
  ];

  // Profile menu items
  const profileMenuItems = [
    { icon: User, label: "Profile", link: "/profile" },
    { icon: Edit, label: "Edit Profile", link: "/edit-profile" },
    { icon: Repeat, label: "Switch User", link: "/switch-user" },
    { icon: LogOut, label: "Log Out", action: () => handleLogout() }
  ];

  // Languages data
  const languages = [
    { flag: usFlag, name: "English", code: "en" },
    { flag: frFlag, name: "French", code: "fr" }
  ];

const handleLogout = async () => {
    try {
      console.log("token : ",token)
      
      if (token) {
        const response = await fetch('https://admin.oceaniabloom9.com/api/user/logout', {
          method: 'GET',
          headers: {
            // 'Authorization': token,
            // 'Content-Type': 'application/json'
             'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          }
        });

        if (!response.ok) {
          console.warn('Logout API returned non-OK status:', response.status);
        } else {
          const result = await response.json();
          console.log('Logout successful:', result);
            dispatch(logout());
      
      // Redirect to login
      navigate('/signin');
        }
      }
    } catch (error) {
      console.error('Logout API error:', error);
      // Continue with local logout
    } finally {
      
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      console.log('Searching for:', searchQuery);
      // Implement search functionality
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        {/* Logo Section */}
        <div className="logo-mini-wrapper">
          <Link to="/dashboard">
            <img src={logo} className="logo-mini" alt="Willow Quantum Logo" />
          </Link>
        </div>

        

        <ul className="navbar-nav">
         
          {/* Profile Dropdown */}
          <li className="nav-item dropdown">
  <button
    className="nav-link dropdown-toggle d-flex align-items-center border-0 bg-transparent"
    onClick={(e) => {
      e.preventDefault();
      setIsProfileOpen(!isProfileOpen);
    }}
    aria-expanded={isProfileOpen}
    aria-haspopup="true"
  >
    {/* small avatar (30x30) */}
    <img
      src={face2}
      alt="Profile"
      className="rounded-circle img-avatar-sm"
      style={{ width: 30, height: 30 }}
    />
  </button>

  {isProfileOpen && (
    <div className="dropdown-menu p-0 show" style={{ minWidth: 220,     right: "-13px",
    top: "37px" }}>
      <div className="d-flex flex-column align-items-center border-bottom px-4 py-3">
        <div className="mb-3">
          <img
            src={face3}
            alt="Profile large"
            className="rounded-circle img-avatar-lg"
            style={{ width: 80, height: 80 }}
          />
        </div>
        <div className="text-center">
          <p className="mb-0 fw-bold">{userData?.name}</p>
          <p className="mb-0 small text-secondary">{userData?.email}</p>
        </div>
      </div>

      <ul className="list-unstyled p-1 mb-0">
        <li>
          <Link to="/profile" className="dropdown-item py-2 d-flex align-items-center">
            <User size={16} className="me-2" />
            <span>Profile</span>
          </Link>
        </li>
        
<li>
  <Link to="/change-password" className="dropdown-item py-2 d-flex align-items-center">
   <Edit size={16} className="me-2" />
    <span>Change Password</span>
  </Link>
</li>
      
        <li>
         <button
  className="dropdown-item py-2 d-flex align-items-center text-danger"
  onClick={() => { 
    handleLogout(); 
    setIsProfileOpen(false);
  }}
  disabled={isLoggingOut}
>
  {isLoggingOut ? (
    <>
      <div className="spinner-border spinner-border-sm me-2" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <span>Logging out...</span>
    </>
  ) : (
    <>
      <LogOut size={16} className="me-2" />
      <span>Log Out</span>
    </>
  )}
</button>
        </li>
      </ul>
    </div>
  )}
</li>

        </ul>

      
      </div>

    
    </nav>
  );
};

export default Navbar;